import patch from "./method.patch";
import dele from "./method.delete";
import post from "./method.post";
import put from "./method.put";
import get from "./method.get";

const api = {
  patch,
  dele,
  post,
  put,
  get,
};

export default api;
